var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb1_SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.9092,
    y1: 411.5636,
    x2: 274.5492,
    y2: 318.6936,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#fb1_SVGID_1_)"
    },
    d: "M313.093,92.571c-2.918,32.805-10.882,64.419-23.891,94.709H180.92  c26.421-40.011,38.787-81.893,37.771-128.434c-0.306-14.783,10.398-27.517,24.987-29.904c0.322-0.048,0.628-0.096,0.952-0.146  C282.802,22.558,316.494,54.026,313.093,92.571z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb1_SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.2702,
    y1: 220.3267,
    x2: 507.7102,
    y2: 103.4567,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#fb1_SVGID_2_)"
    },
    d: "M466.887,179.642l-346.774-0.015v268.858h123.775h162.372h13.497  c35.134,0,65.12-25.398,70.902-60.054l20.715-156.265C515.961,204.672,494.76,179.642,466.887,179.642z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb1_SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.9186,
    y1: 201.7148,
    x2: 152.0086,
    y2: 201.7148,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#fb1_SVGID_3_)"
    },
    d: "M406.261,448.485h13.497c24.736,0,46.906-12.599,59.889-32.145l-294.8-236.712l-64.735-0.003  v268.858h123.776L406.261,448.485z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb1_SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.2192,
    y1: 262.6935,
    x2: 233.2292,
    y2: -31.6365,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3C3C3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#fb1_SVGID_4_)"
    },
    d: "M171.587,464.925h-32.112c-7.75,0-14.033-6.283-14.033-14.033V177.22  c0-7.75,6.283-14.033,14.033-14.033h32.112c7.75,0,14.033,6.283,14.033,14.033v273.672  C185.62,458.643,179.338,464.925,171.587,464.925z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb1_SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.5253,
    y1: 197.3172,
    x2: 46.8353,
    y2: 247.9773,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C3C3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#777777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#fb1_SVGID_5_)"
    },
    d: "M150.124,163.186h-10.65c-7.75,0-14.033,6.283-14.033,14.033v273.673  c0,7.75,6.283,14.033,14.033,14.033h32.112c7.75,0,14.033-6.283,14.033-14.033V198.68L150.124,163.186z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb1_SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.6603,
    y1: 239.2635,
    x2: 180.5493,
    y2: -85.3864,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#62E1FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A2F3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#fb1_SVGID_6_)"
    },
    d: "M135.388,483.996H14.634C6.552,483.996,0,477.444,0,469.362V158.749  c0-8.082,6.552-14.634,14.634-14.634h120.754c8.083,0,14.634,6.552,14.634,14.634v310.612  C150.022,477.444,143.47,483.996,135.388,483.996z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb1_SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.6008,
    y1: 254.9955,
    x2: 20.5598,
    y2: 358.0355,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A2F3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0075CD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#fb1_SVGID_7_)"
    },
    d: "M150.022,234.163l-47.821-47.821c-6.747-7.347-16.429-11.955-27.19-11.955  c-20.386,0-36.912,16.527-36.912,36.912c0,10.761,4.608,20.444,11.955,27.19l99.969,99.968V234.163z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb1_SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.5286,
    y1: 327.1533,
    x2: 74.5286,
    y2: 273.9833,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#fb1_SVGID_8_)"
    },
    cx: 75.013,
    cy: 211.296,
    r: 36.912
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb1_SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.5286,
    y1: 288.1433,
    x2: 74.5286,
    y2: 324.8333,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#fb1_SVGID_9_)"
    },
    cx: 75.013,
    cy: 211.296,
    r: 25.474
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB92D"
    },
    cx: 65.335,
    cy: 201.618,
    r: 5.271
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB92D"
    },
    cx: 84.691,
    cy: 201.618,
    r: 5.271
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB92D"
    },
    cx: 65.335,
    cy: 220.984,
    r: 5.271
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB92D"
    },
    cx: 84.691,
    cy: 220.984,
    r: 5.271
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.b3491fe5cb1d4f3462ac82d7680a47a3.svg";
export { ForwardRef as ReactComponent };